module.exports = __webpack_public_path__ + "img/MetroCebuWaterDistrict(MCWD)_logo@2x.9449b4a7.png";